import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  themeMode: 'light',
  themeDirection: 'ltr',
  width: null,
  imagee: null,
  // Sub-objeto SOLO para la apariencia del TPV camarero. Independiente del
  // themeMode/themeDirection globales (que rigen el resto de la app). Vive
  // dentro del mismo slice porque redux-persist no tiene whitelist en
  // settings (`rootReducer.js:143-147`), así que cualquier campo nuevo
  // persiste a localStorage automáticamente. El campo se hidrata desde el
  // backend (User.TpvLayoutSettingsJson) en authJwt cuando hace login,
  // se merge con defaults en `useTpvLayout`, y se persiste en BD vía
  // POST settings/UpdateTpvLayout.
  // null = nunca configurado → useTpvLayout aplica defaults.
  tpv: null,
  // Configuración de IMPRESIÓN (comanda + ticket de pago). Mismo modelo
  // que `tpv`: opaco, hidratado desde `user.printLayoutSettingsJson` y
  // persistido vía POST settings/UpdatePrintLayout. Lo usa el generador
  // de PDFs en backend + las previews del panel en el front.
  print: null,
};

const slice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    switchMode(state, action) {
      state.themeMode = action.payload;
    },
    switchDirection(state, action) {
      state.themeDirection = action.payload;
    },
    setWithListener(state, action) {
      state.width = action.payload;
    },
    updateImage(state, action) {
      state.imagee = action.payload;
    },
    setTpvLayout(state, action) {
      // payload = objeto completo (o null para resetear a defaults). El
      // panel UI siempre envía el estado completo; el merge contra defaults
      // se hace en lectura, no aquí.
      state.tpv = action.payload || null;
    },
    setPrintLayout(state, action) {
      state.print = action.payload || null;
    },
  }
});

// Reducer
export default slice.reducer;

export const {
  switchMode,
  switchDirection,
  setWithListener,
  updateImage,
  setTpvLayout,
  setPrintLayout,
} = slice.actions;

// Actions
